import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, SparklesIcon } from 'lucide-react';
import { proofPoints, ProofPoint } from '../data/content';
function Card({
  point
}: {
  point: ProofPoint;
}) {
  return <article className="flex h-full flex-col rounded-2xl border border-blue/15 bg-white p-6 shadow-sm shadow-navy/5" data-id="element-172" data-mp="350n9wnuahcp6">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-yellow/25 text-navy" data-id="element-173" data-mp="3a0t348g7j79d">
        <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-174" data-mp="3e0jplzypb183" />
      </span>
      <h3 className="mt-4 font-serif-display text-lg font-bold leading-snug text-navy" data-id="element-175" data-mp="3islcefthwacd">
        {point.title}
      </h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-navy/75" data-id="element-176" data-mp="3nro7b7frh06m">{point.description}</p>
    </article>;
}
export function ProofSection() {
  const [index, setIndex] = useState(0);
  const go = useCallback((dir: number) => {
    setIndex(prev => (prev + dir + proofPoints.length) % proofPoints.length);
  }, []);
  return <section className="w-full bg-white px-5 py-12 sm:py-20" data-id="element-177" data-mp="15ot8dx7o87i2">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="10o5en3s25ck5">
        <div className="mx-auto max-w-2xl text-center" data-id="element-179" data-mp="10qhw7ftwlkwo">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-navy sm:text-4xl" data-id="element-180" data-mp="vqdejmh9ek4v">
            Why this actually gets used
          </h2>
          <p className="mt-3 text-sm text-navy/70 sm:text-base" data-id="element-181" data-mp="rq3a4e9481s4">
            Built around how making really happens at a kitchen table.
          </p>
        </div>

        <div className="mt-10 hidden gap-6 md:grid md:grid-cols-3" data-id="element-182" data-mp="1jfg6po9irvdm">
          {proofPoints.map(point => <Card key={point.title} point={point} data-id="element-183" data-mp="1emdb7al6mbus" />)}
        </div>

        <div className="mt-10 md:hidden" data-id="element-184" data-mp="1altc41h1sy60">
          <div className="relative overflow-hidden" data-id="element-185" data-mp="1akrypqck7zl4">
            <AnimatePresence mode="wait" data-id="element-186" data-mp="275aie2i3rdwa">
              <motion.div key={index} initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -40
            }} transition={{
              duration: 0.3,
              ease: 'easeOut'
            }} data-id="element-187" data-mp="276bvsdmlcch6">
                <Card point={proofPoints[index]} data-id="element-188" data-mp="5ejqpgtswivj" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-5 flex items-center justify-between" data-id="element-189" data-mp="3mtyuqjk47ua3">
            <button type="button" onClick={() => go(-1)} aria-label="Previous point" className="flex h-11 w-11 items-center justify-center rounded-full border border-blue/30 text-blue-deep transition-colors hover:bg-blueprint" data-id="element-190" data-mp="3rtbjxaygldfu">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-191" data-mp="33yia5vj5vwqa" />
            </button>

            <div className="flex gap-2" data-id="element-192" data-mp="38wtlkap3ufam">
              {proofPoints.map((point, i) => <button key={point.title} type="button" onClick={() => setIndex(i)} aria-label={`Go to point ${i + 1}`} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? 'w-6 bg-blue' : 'w-2 bg-blue/25'}`} data-id="element-193" data-mp="126vq6dxot23b" data-mpi={i} />)}
            </div>

            <button type="button" onClick={() => go(1)} aria-label="Next point" className="flex h-11 w-11 items-center justify-center rounded-full border border-blue/30 text-blue-deep transition-colors hover:bg-blueprint" data-id="element-194" data-mp="31ec67nujs69q">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-195" data-mp="36doqc0u1az8m" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}